module.exports = __webpack_public_path__ + "24e004ab/img/google.68f3823e.svg";